import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import SideBar from "../SideBar";

/** The app's main sidebar on a learning page, for support agents (admins get AdminSideBar). Mounted the way Batch Mode does. */
export default function LearningAgentSideBar({ onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <SideBar mode="agent" onLogout={onLogout} isDarkMode={false} onToggleTheme={() => {}}
      onLinkClick={(path) => navigate(path)} currentPath={location.pathname} />
  );
}
